import store from "../../index.js";
import api from "../../../utils/api";

export const modules = {
  store,
};

export const state = {};

export const mutations = {};

export const actions = {
  async acPayOrderPriceInfo({ commit }, { rent_amount, discount_amount }) {
    const url = "/api/v1/pay-order/price";
    try {
      const res = await api.post(`${url}`, {
        base_price: rent_amount,
        discount_amount: discount_amount,
      });
      return res.data.data;
    } catch (error) {
      return null;
    }
  },
  async acPayOrderInfo({ commit }, payload) {
    const url = "/api/v1/pay-order/info";
    try {
      const res = await api.post(`${url}`, payload);
      return res.data;
    } catch (error) {
      return null;
    }
  },
  async acPayOrderInfoReorder(
    { commit },
    { encoded_doby_seq, rental_amount, payment_price, pg_name, pay_order_type, pay_order_option },
  ) {
    const url = "/api/v1/pay-order/info/reorder";
    try {
      const res = await api.post(`${url}`, {
        encoded_doby_seq,
        rental_amount,
        payment_price,
        pg_name,
        pay_order_type,
        pay_order_option,
      });
      return res.data;
    } catch (error) {
      return null;
    }
  },
  /* 카드 등록 정보 조회 */
  async acPayOrderInfoRegisterCard({ commit }, { encoded_doby_seq, conversion_path }) {
    const url = "/api/v1/pay-order/info/register-card";
    try {
      const res = await api.post(`${url}`, {
        encoded_doby_seq,
        conversion_path,
      });
      return res.data;
    } catch (error) {
      return null;
    }
  },
  async acPayOrderPayment({ commit }, payload) {
    const url = "/api/v1/pay-order/payment";
    try {
      const res = await api.post(`${url}`, { ...payload });
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acPayOrderPaymentBillingKey({ commit }, payload) {
    const url = "/api/v1/pay-order/payment/billing-key";
    try {
      const res = await api.post(`${url}`, { ...payload });
      return {
        success: res.data?.code === 0,
        message: res.data?.message,
        data: res.data?.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "결제 처리 중 오류가 발생했습니다.",
        data: null,
      };
    }
  },
  async acPayOrderComplete({ commit }, params) {
    try {
      const res = await api.post(`/api/v1/pay-order-complete`, params);
      return res.data.code === 0;
    } catch (error) {
      return false;
    }
  },
  /* 카드 등록 완료 처리 */
  async acPayOrderRegisterCardComplete({ commit }, params) {
    try {
      const res = await api.post(`/api/v1/pay-order-complete/register-card`, params);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 0:
        return "";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
